
import { Link, useNavigate } from "react-router-dom";
import { useT } from "../i18n";
import LangToggle from "./LangToggle";

const FullpageHeader = ({ userInfo , logout}) => {
    const t = useT();
    const navigate =useNavigate();
    
    return(
        <div className="header_bg">
            <div className="width_con">
                <header>
                    <input className="burger-check" type="checkbox" id="burger-check" />
                    <label className="burger-icon" htmlFor="burger-check">
                    <span className="burger-sticks"></span>
                    </label>
                    <div className="menu">
                        <ul className="menu_contents">
                            {userInfo === null ? 
                            <li><Link to='/login' state={{ returnUrl : window.location.href}}>{t('Log In')}</Link></li> :
                            <>                 
                            <li><a onClick={logout} href="#">{t('Log Out')}</a></li>
                            </>
                            }
                            <li className="about"><Link to='/about'>{t('About')}</Link></li>
                            {/* <li className="people"><Link to=''>People</Link></li> */}
                            {/* <li><a href="/project">Project</a></li> */}
                            <li className="people"><Link to='/people'>{t('People')}</Link></li>
                            <li className="news">
                                <Link to="/news">{t('News')}</Link>
                            </li>
                            {userInfo !== null && (
                                <li className="my_page">
                                    <Link to="/mypage">{t('My page')}</Link>
                                </li>
                            )}
                            <li className="lang">
                                <LangToggle />
                            </li>
                        </ul>
                    </div>
                <div className={`btns btn_map`} onClick={()=>{navigate('/map')}}>
                    <img src={process.env.PUBLIC_URL+"images/icon_map_go.png"}></img>
                <div className="hover_box">
                    {t("지도 보러가기")}
                </div>
                </div>
                </header>                
            </div>
        </div>
    )
}

export default FullpageHeader;